import React from "react";
import { useState, useEffect } from "react";
import { FiPlusSquare, FiEdit } from "react-icons/all";
import CreateMessage from "../../components/CreateMessage";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import "./messages.css";
import MessagesListComponent from "./messagesListComponent";
import {
  CreateNewMessages,
  UpdateMessages,
  deleteMessages,
  getMessages,
} from "../../Data/Messages";

function Messages() {
  const [openCreateMessage, setOpenCreateMessage] = useState(false);
  const [Allmessages, setMessages] = useState([]);

  useEffect(() => {
    const fecthMessages = async () => {
      const Messages = getMessages();
      setMessages(
        (await Messages).docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };
    return fecthMessages();
  }, [Allmessages]);

  return (
    <div className="container">
      <div className="bar">
        <button className="msg-btn" onClick={() => setOpenCreateMessage(false)}>
          {" "}
          <FiPlusSquare /> messages{" "}
        </button>
        <button
          className="msg-btn"
          onClick={() => setOpenCreateMessage(!openCreateMessage)}
        >
          <FiEdit /> create{" "}
        </button>
      </div>
      <div className="divider"></div>

      {openCreateMessage ? (
        <CreateMessage
          btnName="Create"
          titleName="Create new Messages"
          messagesData=""
          submitType="Create"
        />
      ) : (
        <>
          <h1>
            <center>Messages</center>
          </h1>
          <hr />
          <br />
          {Allmessages.map((messages) => {
            return (
              <MessagesListComponent messagesData={messages} key={messages.id} />
            );
          })}

          <br />
        </>
      )}
    </div>
  );
}

export default Messages;
